import { useEffect, useRef, useState } from "react";
import { Platform, ScrollView } from "react-native";

const useSyncedHorizontalScrollbar = (initialContentWidth = 1) => {
  const tableScrollRef = useRef<ScrollView>(null);
  const topScrollBarRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState(initialContentWidth);

  useEffect(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return;

    const top = topScrollBarRef.current;
    const bottom = (tableScrollRef.current as any)?.getScrollableNode?.() as HTMLElement | null;

    if (!top || !bottom) return;

    let syncing = false;
    const fromTop = () => {
      if (syncing) return;
      syncing = true;
      bottom.scrollLeft = top.scrollLeft;
      syncing = false;
    };
    const fromBottom = () => {
      if (syncing) return;
      syncing = true;
      top.scrollLeft = bottom.scrollLeft;
      syncing = false;
    };

    top.addEventListener("scroll", fromTop, { passive: true });
    bottom.addEventListener("scroll", fromBottom, { passive: true });

    return () => {
      top.removeEventListener("scroll", fromTop);
      bottom.removeEventListener("scroll", fromBottom);
    };
  }, [contentWidth]);

  const handleContentWidthChange = (width: number) => {
    if (width > 0 && width !== contentWidth) {
      setContentWidth(width);
    }
  };

  return {
    tableScrollRef,
    topScrollBarRef,
    contentWidth,
    handleContentWidthChange,
  };
};

export default useSyncedHorizontalScrollbar;